import React from "react";
import { Modal, Button } from "react-bootstrap";
import { md, pct } from "./promoRadarData";

export default function PromoBriefModal({
  show,
  campaign,
  nights,
  onClose,
  onToast,
}) {
  if (!show || !campaign) return null;

  const c = campaign;
  const steps = c.covered
    ? [
        `Open ${c.covered} in the ${c.owner} extranet.`,
        `Add these nights to its stay dates: ${c.nights.map((x) => md(x.d)).join(", ")}.`,
        "Keep blackout nights excluded.",
        "Save and mark the task done in RevEVOLVE.",
      ]
    : [
        `In the ${c.owner} extranet, create a ${c.type.toLowerCase()} promotion named "${c.name}".`,
        c.disc
          ? `Set the discount to ${pct(c.disc)} off BAR.`
          : "Set it as a value-add (package or minimum stay), with no rate cut.",
        `Stay nights: ${c.nights.map((x) => md(x.d)).join(", ")}.`,
        `Exclude every blackout night: ${nights?.filter(
          (x) =>
            x.blackout &&
            x.n >= c.nights[0].n &&
            x.n <= c.nights[c.nights.length - 1].n,
        ).map((x) => md(x.d)).join(", ") || "none in this span"}.`,
        `Target: ${c.target} rooms behind last year.`,
        "Enter the promotion code in RevEVOLVE so bookings are tracked.",
      ];

  const sendToRM = () => {
    onClose();
    if (onToast) onToast("Brief sent to the RM task list");
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      size="md"
      className="promo-radar-brief-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title style={{ width: "100%" }}>
          <div style={{ fontSize: "12px", fontWeight: 500, color: "#64748b", marginBottom: "3px" }}>
            {c.owner}, {c.type}
          </div>
          <div style={{ fontSize: "18px", fontWeight: 700, color: "#1e293b" }}>
            {c.covered ? `Adjust ${c.covered}` : `Set up ${c.name}`}
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ padding: "20px 24px" }}>
        <ol style={{ margin: 0, paddingLeft: "20px", lineHeight: 1.8, fontSize: "14px", color: "#334155" }}>
          {steps.map((s, idx) => (
            <li key={idx} style={{ marginBottom: idx === steps.length - 1 ? 0 : "10px" }}>
              {s}
            </li>
          ))}
        </ol>
      </Modal.Body>
      <Modal.Footer style={{ padding: "12px 24px", borderTop: "1px solid #eaefff" }}>
        {/* <Button
          className="secondary-btn"
          type="button"
          onClick={copyBrief}
          style={{ height: "36px", padding: "0 16px", fontSize: "13px" }}
        >
          Copy brief
        </Button> */}
        <Button
          className="default-btn primary-btn"
          type="button"
          onClick={sendToRM}
          style={{
            height: "36px",
            padding: "0 22px",
            fontSize: "13.5px",
            fontWeight: 600,
            borderRadius: "5px",
          }}
        >
          Send to RM
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
